import { OidcAccessToken, OidcClient, OidcTokenStorage } from '@ori/auth';

import { log } from '../helpers';
import { IDENTITY_CLIENT_ID, NodeEnv } from '~/constants';
import type { TokenConfiguration } from '~/models';

export async function getToken({ forceReload, identityUrl, tenant }: TokenConfiguration) {
  if (window.ori?.tokenService) {
    const oriToken = await window.ori.tokenService.getToken();

    if (oriToken) {
      return new OidcAccessToken(oriToken.Token);
    }
  }

  // only on dev machine, not needed elsewhere
  if (process.env.NODE_ENV !== NodeEnv.Production) {
    const oidcTokenStorage = new OidcTokenStorage();
    let token;

    try {
      token = oidcTokenStorage.getAccessToken();
    } catch {
      // no action here
    }

    if (token && !forceReload) {
      return token;
    }
    if (identityUrl) {
      const clientId = IDENTITY_CLIENT_ID;

      const oidcClient = new OidcClient(
        {
          callbackUrl: '#/',
          redirectUrl: window.location.href,
        },
        {
          acrValues: `tenant:${tenant}`,
          clientId,
          identityUrl,
          scope: 'openid profile user_identification all',
        },
      );

      oidcClient.doLogin();
    }
  }

  log(
    `Couldn't get auth token.`,
    '\n\twindow.ori.tokenService',
    window.ori?.tokenService,
    '\n\tidentityUrl',
    identityUrl,
  );
  throw new Error('Unsupported token configuration');
}
